import { withPrefix } from 'gatsby';
import focusFirstAvailableElement from '#/shared/utils/focus-first-available-element';
import wrapRootElement from './.gatsby/wrap-root-element';

// TODO: Once the below ticket is resolved `core-js` imports here can be
//  removed and the package should be removed from the package.json since it
//  should come in as a transitive dependency via Gatsby, while it remains
//  an explicit its version need to be synced with the version Gatsby
//  requires: https://trimet.atlassian.net/browse/PUBWEB-1751
import 'core-js/actual/array/at';

// disable gatsby's scroll restoration so that it doesn't disrupt
// the programmatic scrolling that done to reset the map size on mobile
const shouldUpdateScroll = () => false;

/**
 * Using gatsby's onRouteUpdate to manage focus when navigating between content changes on content panel.
 * This is necesary since the content panel when refreshed, the focus goes back to the top of the page
 * and screen reader users can get lost.
 * References:
 * https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#onRouteUpdate
 * https://www.gatsbyjs.com/blog/2020-07-31-the-worlds-sneakiest-route-change/
 */

export const onRouteUpdate = ({ location, prevLocation }) => {
  // checks the prevLocation if it's null this would be usually on page load
  if (!prevLocation) return;

  // Skips the Search Page to avoid focus management conflict
  const searchPath = withPrefix('/search/');
  if (location.pathname === searchPath) return;

  /**
   * Skip automatic refocus behavior when the currently focused element
   * has the `data-refocus-skip="true"` attribute.
   *
   * This attribute (accessed via `dataset.refocusSkip`) can be applied
   * to any interactive element
   */
  const active = document.activeElement;
  if (active?.dataset.refocusSkip === 'true') return;

  if (location.pathname !== prevLocation?.pathname) {
    focusFirstAvailableElement();
  }
};

export { wrapRootElement, shouldUpdateScroll };
